module.exports = __webpack_public_path__ + "static/media/5DPO13.4ec315df.jpg";